(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["n69bwj-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('n69bwj-announcement-bar')) {
    class N69bwjAnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.rotateTimeout = null;
      }

      connectedCallback() {
        this.messages = this.querySelectorAll('.n69bwj-announcement-bar__message');
        this.track = this.querySelector('[data-ref="track"]');
        this.liveRegion = this.querySelector('[data-ref="live"]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.messages.length) return;

        /* Dismiss: check sessionStorage */
        if (this.dataset.dismissible !== undefined) {
          const sectionId = this.closest('.shopify-section')?.id || 'announcement';
          if (sessionStorage.getItem('n69bwj-announcement-dismissed-' + sectionId) === 'true') {
            this.classList.add('is-dismissed');
            return;
          }
        }

        /* Initialise slide state (no announce on first paint) */
        this.applyActiveState(false);

        /* Re-evaluate scroll-on-overflow when width / fonts change */
        if (this.dataset.overflow === 'scroll' && !this.reduceMotion && 'ResizeObserver' in window) {
          this._ro = new ResizeObserver(() => this.updateOverflow());
          this._ro.observe(this);
        }

        /* Arrow controls */
        const prevBtn = this.querySelector('[data-direction="prev"]');
        const nextBtn = this.querySelector('[data-direction="next"]');

        if (prevBtn) {
          prevBtn.addEventListener('click', () => this.navigate(-1));
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', () => this.navigate(1));
        }

        /* Dismiss button */
        const dismissBtn = this.querySelector('.n69bwj-announcement-bar__dismiss');
        if (dismissBtn) {
          dismissBtn.addEventListener('click', () => this.dismiss());
        }

        /* Auto-rotate (skip under reduced motion — manual arrows still work) */
        if (this.dataset.autoRotate === 'true' && this.messages.length > 1 && !this.reduceMotion) {
          this.startAutoRotate();

          this.addEventListener('mouseenter', () => this.stopAutoRotate());
          this.addEventListener('mouseleave', () => this.startAutoRotate());
          this.addEventListener('focusin', () => this.stopAutoRotate());
          this.addEventListener('focusout', () => this.startAutoRotate());

          /* Pause when the tab is hidden (battery + INP friendly) */
          this._onVisibility = () => {
            if (document.hidden) {
              this.stopAutoRotate();
            } else {
              this.startAutoRotate();
            }
          };
          document.addEventListener('visibilitychange', this._onVisibility);
        }
      }

      disconnectedCallback() {
        this.stopAutoRotate();
        if (this._onVisibility) {
          document.removeEventListener('visibilitychange', this._onVisibility);
          this._onVisibility = null;
        }
        if (this._ro) {
          this._ro.disconnect();
          this._ro = null;
        }
      }

      navigate(direction) {
        this.currentIndex = (this.currentIndex + direction + this.messages.length) % this.messages.length;
        this.applyActiveState(true);
      }

      applyActiveState(announce) {
        for (let i = 0; i < this.messages.length; i++) {
          const message = this.messages[i];
          const active = i === this.currentIndex;
          message.classList.toggle('is-active', active);
          if (active) {
            message.removeAttribute('aria-hidden');
          } else {
            message.setAttribute('aria-hidden', 'true');
          }
          const link = message.querySelector('a');
          if (link) link.tabIndex = active ? 0 : -1;
        }
        if (this.track) {
          this.track.style.setProperty('--n69bwj-ab-index', this.currentIndex);
        }
        if (announce && this.liveRegion) {
          this.liveRegion.textContent = (this.currentIndex + 1) + ' / ' + this.messages.length;
        }
        this.updateOverflow();
      }

      /* Marquee the active message only if its text actually overflows */
      updateOverflow() {
        if (this.dataset.overflow !== 'scroll' || this.reduceMotion) return;
        const active = this.messages[this.currentIndex];
        if (!active) return;
        const textEl = active.querySelector('.n69bwj-announcement-bar__text');
        const inner = active.querySelector('.n69bwj-announcement-bar__text-inner');
        if (!textEl || !inner) return;
        /* Measure the clip container (nowrap): scrollWidth = full text, clientWidth = visible */
        const dist = textEl.scrollWidth - textEl.clientWidth;
        if (dist > 4) {
          const dur = Math.max(4, dist / 60);
          textEl.style.setProperty('--n69bwj-ab-scroll-dist', '-' + dist + 'px');
          textEl.style.setProperty('--n69bwj-ab-scroll-dur', dur + 's');
          textEl.classList.add('is-scrolling');
        } else {
          textEl.classList.remove('is-scrolling');
        }
      }

      startAutoRotate() {
        this.stopAutoRotate();
        this.scheduleNext();
      }

      /* Self-scheduling so a slide carrying a timer is held longer (readable) */
      scheduleNext() {
        const base = parseInt(this.dataset.rotateSpeed, 10) || 5;
        const active = this.messages[this.currentIndex];
        const hasTimer = active && active.querySelector('n69bwj-countdown');
        const delay = (hasTimer ? Math.max(base, 8) : base) * 1000;
        this.rotateTimeout = setTimeout(() => {
          this.navigate(1);
          this.scheduleNext();
        }, delay);
      }

      stopAutoRotate() {
        if (this.rotateTimeout) {
          clearTimeout(this.rotateTimeout);
          this.rotateTimeout = null;
        }
      }

      dismiss() {
        this.classList.add('is-dismissed');
        this.stopAutoRotate();
        const sectionId = this.closest('.shopify-section')?.id || 'announcement';
        try {
          sessionStorage.setItem('n69bwj-announcement-dismissed-' + sectionId, 'true');
        } catch (e) {
          /* sessionStorage may be unavailable — fail silently */
        }
      }
    }

    customElements.define('n69bwj-announcement-bar', N69bwjAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n69bwj-authority-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__n69bwjAuthorityRevealInit) return;
    window.__n69bwjAuthorityRevealInit = true;
    var run = function () {
      var els = document.querySelectorAll('[data-n69bwj-reveal]:not(.is-visible)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = parseInt(entry.target.getAttribute('data-n69bwj-reveal-delay') || '0', 10);
            setTimeout(function () { entry.target.classList.add('is-visible'); }, delay);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      els.forEach(function (el) { io.observe(el); });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n69bwj-icon-bar"] && !Shopify.designMode) return;
  try {
    
  // Les fleches et la barre d'avancement de `card_row`. Le defilement lui-meme
  // est natif (scroll-snap) : ce code ne fait que le commander et refleter ou
  // l'on en est. Garde idempotent — ce bloc est groupe pour tout le theme et
  // peut etre evalue plus d'une fois.
  (function () {
    if (window.__n69bwjIconBarWired) return;
    window.__n69bwjIconBarWired = true;

    function largeurDUnePas(piste) {
      var premier = piste.firstElementChild;
      return premier ? premier.getBoundingClientRect().width : piste.clientWidth;
    }

    function refletePosition(barre, piste) {
      var course = piste.scrollWidth - piste.clientWidth;
      var part = course > 0 ? piste.scrollLeft / course : 0;
      var n = piste.children.length || 1;
      var mini = 1 / n;
      barre.style.setProperty('--ib-progress', Math.max(mini, part) * 100 + '%');
    }

    function cabler(section) {
      // Garde PAR ELEMENT. Le garde global ne protege que ce fichier ; sans
      // celui-ci, chaque `shopify:section:load` rattache un jeu d'ecouteurs de
      // plus et la fleche avance de deux cartes, puis trois. Silencieux.
      if (section.dataset.ibWired) return;
      var piste = section.querySelector('[data-ib-piste]');
      var barre = section.querySelector('[data-ib-bar]');
      var prev = section.querySelector('[data-ib-prev]');
      var next = section.querySelector('[data-ib-next]');
      if (!piste || !barre || !prev || !next) return;
      section.dataset.ibWired = '1';

      function reflete() {
        var course = piste.scrollWidth - piste.clientWidth;
        // Le CSS prevoit un etat desactive ; sans ces deux lignes il n'etait
        // jamais pose, et la derniere fleche restait pleinement contrastee
        // tout en ne faisant rien.
        prev.disabled = piste.scrollLeft <= 1;
        next.disabled = piste.scrollLeft >= course - 1;
        refletePosition(barre, piste);
      }

      prev.addEventListener('click', function () {
        piste.scrollBy({ left: -largeurDUnePas(piste), behavior: mouvement() });
      });
      next.addEventListener('click', function () {
        piste.scrollBy({ left: largeurDUnePas(piste), behavior: mouvement() });
      });
      piste.addEventListener('scroll', reflete, { passive: true });
      reflete();
    }

    function mouvement() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    function tout(e) {
      // Sur un rechargement de section, ne parcourir QUE cette section.
      var racine = e && e.target && e.target.querySelectorAll ? e.target : document;
      racine.querySelectorAll('.n69bwj-icon-bar[data-layout="card_row"]').forEach(cabler);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }
    document.addEventListener('shopify:section:load', tout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n69bwj-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class N69bwjProductRecommendations extends HTMLElement {
    connectedCallback() {
      // burns merchant bandwidth on hover-prerendered PDPs that never activate.
      if (document.prerendering) {
        document.addEventListener('prerenderingchange', () => this.connectedCallback(), { once: true });
        return;
      }

      const url = this.dataset.url;
      if (!url) return;

      const observer = new IntersectionObserver((entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        this.loadRecommendations(url);
      }, { rootMargin: '200px' });

      observer.observe(this);
    }

    async loadRecommendations(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) return;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('n69bwj-product-recommendations');

        if (fresh && fresh.innerHTML.trim().length > 0) {
          this.innerHTML = fresh.innerHTML;
        }
      } catch (error) {
        if (window.Shopify && window.Shopify.designMode) {
          console.error('Product recommendations failed:', error);
        }
      }
    }
  }

  if (!customElements.get('n69bwj-product-recommendations')) {
    customElements.define('n69bwj-product-recommendations', N69bwjProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n69bwj-sale-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__n69bwjSaleCountdownInit) return;
    window.__n69bwjSaleCountdownInit = true;
    function checkExpiry(section) {
      var iso = section.getAttribute('data-end-iso');
      if (!iso) return;
      var end = new Date(iso).getTime();
      if (!isFinite(end)) return;
      var now = Date.now();
      if (now >= end) {
        if (section.getAttribute('data-auto-hide') === 'true') {
          section.hidden = true;
          return;
        }
        var ended = section.querySelector('[data-ref="ended"]');
        var timer = section.querySelector('[data-ref="timer"]');
        if (ended) ended.hidden = false;
        if (timer) timer.hidden = true;
      }
    }
    function init() {
      var sections = document.querySelectorAll('.n69bwj-sale-countdown');
      sections.forEach(function (section) {
        checkExpiry(section);
        var iso = section.getAttribute('data-end-iso');
        if (!iso) return;
        var interval = setInterval(function () {
          checkExpiry(section);
          if (section.hidden) clearInterval(interval);
        }, 1000);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n69bwj-timeline"] && !Shopify.designMode) return;
  try {
    
  
  // rAF-throttled, passive listeners, idempotent guard.
  (function () {
    if (window.__n69bwjTimelineInit) return;
    window.__n69bwjTimelineInit = true;

    var sections = [];
    var ticking = false;

    function collect() {
      sections = Array.prototype.slice.call(document.querySelectorAll('.n69bwj-timeline'));
    }

    function update() {
      ticking = false;
      var winH = window.innerHeight;
      for (var i = 0; i < sections.length; i++) {
        var el = sections[i];
        var rect = el.getBoundingClientRect();
        // Progress 0 when section top hits 80% of viewport (just entered);
        // Progress 1 when section bottom hits 20% of viewport (almost gone).
        var startY = winH * 0.8;
        var endY = winH * 0.2;
        var p = (startY - rect.top) / (startY + rect.height - endY);
        if (p < 0) p = 0;
        if (p > 1) p = 1;
        el.style.setProperty('--n69bwj-tl-progress', p.toFixed(3));
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function init() {
      collect();
      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:unload', collect);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmk-avis"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MAX_DOTS = 16;
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      root.querySelectorAll('.nmk-avis__card').forEach(function (card) {
        var text = card.querySelector('[data-text]');
        var more = card.querySelector('[data-more]');
        if (!text || !more) return;
        more.hidden = text.scrollHeight <= text.clientHeight + 2;
        more.addEventListener('click', function () {
          card.classList.add('is-open');
          more.hidden = true;
        });
      });
      var track = root.querySelector('[data-track]');
      var dotsBox = root.querySelector('[data-dots]');
      if (!track || !dotsBox) return;
      var dots = [];
      function build() {
        var max = track.scrollWidth - track.clientWidth;
        dotsBox.innerHTML = '';
        dots = [];
        if (max <= 4) { dotsBox.hidden = true; return; }
        var n = Math.min(MAX_DOTS, track.querySelectorAll('.nmk-avis__card').length);
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', (i + 1) + ' / ' + n);
          b.addEventListener('click', (function (k) {
            return function () { track.scrollTo({ left: (track.scrollWidth - track.clientWidth) * k / (n - 1), behavior: 'smooth' }); };
          })(i));
          dotsBox.appendChild(b);
          dots.push(b);
        }
        dotsBox.hidden = false;
        update();
      }
      function update() {
        if (!dots.length) return;
        var max = track.scrollWidth - track.clientWidth;
        var k = max > 0 ? Math.round(track.scrollLeft / max * (dots.length - 1)) : 0;
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === k ? 'true' : 'false'); });
      }
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', build, { passive: true });
      build();
    }
    function all(scope) { (scope || document).querySelectorAll('[data-nmk-avis]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmk-comparatif-onglets"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
      function select(tab, focus) {
        var id = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        root.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === id); });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          select(tabs[(i + dir + tabs.length) % tabs.length], true);
        });
      });
    }
    function all(scope) { (scope || document).querySelectorAll('[data-nmk-cmp]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target.closest && e.target.closest('[data-panel]');
      if (!panel) return;
      var root = panel.closest('[data-nmk-cmp]');
      var tab = root && root.querySelector('[data-tab="' + panel.getAttribute('data-panel') + '"]');
      if (tab) tab.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmk-ingredients-carrousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var scroller = root.querySelector('[data-scroller]');
      var cards = Array.prototype.slice.call(scroller.children);
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var dotsWrap = root.querySelector('[data-dots]');
      var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (cards.length < 2) { dotsWrap.parentNode.hidden = true; return; }
      function step() { return cards[1].offsetLeft - cards[0].offsetLeft; }
      function index() { return Math.max(0, Math.min(cards.length - 1, Math.round(scroller.scrollLeft / step()))); }
      cards.forEach(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nmk-ing__dot';
        b.setAttribute('aria-label', (i + 1) + ' / ' + cards.length);
        b.addEventListener('click', function () { scroller.scrollTo({ left: i * step(), behavior: smooth }); });
        dotsWrap.appendChild(b);
      });
      var dots = Array.prototype.slice.call(dotsWrap.children);
      function update() {
        var atEnd = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 2;
        var idx = atEnd ? cards.length - 1 : index();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        prev.disabled = scroller.scrollLeft <= 2;
        next.disabled = atEnd;
      }
      prev.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: smooth }); });
      next.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: smooth }); });
      scroller.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function all(scope) { (scope || document).querySelectorAll('[data-nmk-ing]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmk-parcours"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var list = root.querySelector('[data-list]');
      var items = Array.prototype.slice.call(list.querySelectorAll('[data-item]'));
      var fill = list.querySelector('[data-fill]');
      var track = list.querySelector('[data-track]');
      if (!items.length) return;
      var markers = items.map(function (it) { return it.querySelector('[data-marker]'); });
      function rel(m, top) { var r = m.getBoundingClientRect(); return r.top - top + r.height / 2; }
      function update() {
        var top = list.getBoundingClientRect().top;
        var trigger = window.innerHeight * 0.62;
        var first = rel(markers[0], top);
        var last = rel(markers[markers.length - 1], top);
        track.style.top = fill.style.top = first + 'px';
        track.style.height = Math.max(0, last - first) + 'px';
        var lastOn = null;
        markers.forEach(function (m, i) {
          var r = m.getBoundingClientRect();
          var on = r.top + r.height / 2 <= trigger;
          items[i].classList.toggle('is-active', on);
          if (on) lastOn = rel(m, top);
        });
        fill.style.height = (lastOn === null ? 0 : Math.max(0, lastOn - first)) + 'px';
      }
      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      window.addEventListener('load', update);
      update();
    }
    function all(scope) { (scope || document).querySelectorAll('[data-nmk-pj]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmk-photo-cartes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var cta = e.target.closest && e.target.closest('.nmk-pc [data-scroll-to-buy]');
      if (!cta) return;
      var target = document.querySelector('.n69bwj-qty-breaks, [data-product-info], form[action*="/cart/add"]');
      if (!target) return;
      e.preventDefault();
      var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 110, behavior: smooth });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
